"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TASKTYPE = {
    manualLogin: "manualLogin",
    idCard: "idcard",
    register: "register",
    doubleConfirm: "doubleConfirm",
    gpy: "gpy",
    qrCodeLogin: "qrCodeLogin",
    faceScanAuth: "faceScanAuth",
    signature: "signature",
    commentAndRate: "commentAndRate",
    selectUserType: "selectUserType",
    esign: 'esign',
    webViewDisplay: "webViewDisplay",
};
exports.TASKTYPE = TASKTYPE;
var PROCESS = {
    failed: "failed",
    pending: "pending",
    processing: "processing",
    success: "success",
    aborted: "aborted",
    expired: "expired",
};
exports.PROCESS = PROCESS;
exports.COMMON_VARIABLE = {
    person: "person",
    legal: "legal",
};
exports.PORTAL_PREFEX = "/newHall";
